module.exports = __webpack_public_path__ + "static-portal/img/8-1.fbbfb74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/8-1.jpg
// module id = p9lw
// module chunks = 4